module.exports = __webpack_public_path__ + "static/media/number01.98e2faab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/number01.svg
// module id = 927
// module chunks = 0